import Icon from './components/Icon';
import './IconCaret.scss';
const IconCaret = ({ orientation, thin = false, ...props }: any) => {
	const id: string = thin ? `nav-thin-caret--${orientation}` : `nav-caret--${orientation}`;
	return <Icon id={id} handle={props.handle} {...props} />;
};

export default IconCaret;
